import { type UseMutationResult, useMutation, useQueryClient } from 'react-query';
import { toast } from 'react-toastify';
import ToastComponent from '../../components/toast';
import {
  TrustedDeviceService,
  type Wealthlane_Shared_Hosting_Dtos_GenericApiResponse,
} from '../../services/wealthlane-identity-services';

const usePostRevokeTrustedDevice = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  closeModal: () => void
): UseMutationResult<
  Wealthlane_Shared_Hosting_Dtos_GenericApiResponse | undefined,
  unknown,
  string,
  unknown
> => {
  const queryClient = useQueryClient();

  return useMutation(
    async (id: string) => {
      return await handleRequest(
        TrustedDeviceService.postApiIdentityApiAppTrustedDeviceRevoke(id)
      );
    },
    {
      onSuccess: (response: any) => {
        if (response != null) {
          toast.success(
            <ToastComponent label='Success' message={response?.message ?? 'Trusted device access revoked.'} />
          );
          void queryClient.invalidateQueries('getTrustedDevices');
          closeModal();
        }
      },
      onError: (err) => {
        console.log('error', err);
      },
    }
  );
};

export default usePostRevokeTrustedDevice;
